import {Component} from 'preact';
import {Message, SelectField, TrackedFields} from '@ultradent/components';
import equals from 'ramda/src/equals';
import pick from 'ramda/src/pick';

const i18nText = upi.i18n.getTextFromKey;
const fieldClass = 'mb-2 mr-2 md:flex-none md:w-48';
const lblStarsOnly = i18nText( 'lbl-numStarsOnly' );
const lblStarOnly = i18nText( 'lbl-numStarOnly' );
const lblAllStars = i18nText( 'lbl-allStars' );
const lblMyReviews = i18nText( 'lbl-myReviews' );
const lblAllReviews = i18nText( 'lbl-allReviews' );
const lblTopReviews = i18nText( 'lbl-TopReviews' );
const lblFilterBy = i18nText( 'lbl-filterBy' );
const lblErrorFilteringReviews = i18nText( 'lbl-errorFilteringReviews' );

class ReviewFilter extends Component {

    shouldComponentUpdate ( nextProps, nextState ) {
        const propList = ['currentFilters'];

        return !equals(
            pick( propList, nextProps ),
            pick( propList, this.props )
        );
    }

    render ( props, state, {user} ) {

        return (
            <TrackedFields
                initialValues={props.currentFilters}
                onChange={props.onFilterChange}
                render={( {values, handleChange} ) => {
                    return (
                        <div>
                            <h1 className="mb-2">{lblTopReviews}</h1>
                            <h4 className="mb-2 font-normal">{lblFilterBy}</h4>
                            <div className="flex flex-wrap">
                                {user.isLogged ?
                                    <SelectField
                                        id="userReviews"
                                        className={`flex-1 ${fieldClass}`}
                                        value={values.userReviews}
                                        onChange={handleChange}>
                                        <option value="MY REVIEWS">{lblMyReviews}</option>
                                        <option value="ALL REVIEWS">{lblAllReviews}</option>
                                    </SelectField>
                                    : null
                                }
                                <SelectField
                                    id="rating"
                                    className={`flex-1 ${fieldClass}`}
                                    value={values.rating}
                                    onChange={handleChange}>
                                    <option value="5">5 {lblStarsOnly}</option>
                                    <option value="4">4 {lblStarsOnly}</option>
                                    <option value="3">3 {lblStarsOnly}</option>
                                    <option value="2">2 {lblStarsOnly}</option>
                                    <option value="1">1 {lblStarOnly}</option>
                                    <option value="ALL RATINGS">{lblAllStars}</option>
                                </SelectField>
                                {user.isReviewModerator ?
                                    <SelectField
                                        id="status"
                                        className={`flex-2 w-full ${fieldClass}`}
                                        value={values.status}
                                        onChange={handleChange}>
                                        <option value="PENDING">Pending</option>
                                        <option value="PUBLISHED">Published</option>
                                        <option value="DENIED">Denied</option>
                                        <option value="ALL STATUSES">All review statuses</option>
                                    </SelectField>
                                    : null
                                }
                            </div>
                            {props.error &&
                                <Message notice className="my-4">{lblErrorFilteringReviews}</Message>
                            }
                        </div>
                    );
                }}
            />
        );
    }
}

export default ReviewFilter;